import { useState } from 'react'
import { Box, Button, HStack, Text, Textarea, VStack } from '@chakra-ui/react'
import { toaster } from '@/components/ui/toaster'
import { useAddCanvasserNote } from '../../../../hooks/useCanvasser'
import type { ContactDetail } from '../../../../types/contactDetail'
import { shortDay } from './HistorySection'

const MAX_NOTE = 2000 // = ValidationLimits.MaxCanvasserNoteLength (P5-11)

/** [Spec §4.7] Notes, newest first, plus "Add a note" (needs a connection, and says so). */
export function NotesSection({ contactId, detail, isOnline }: { contactId: string; detail: ContactDetail; isOnline: boolean }) {
  const [text, setText] = useState('')
  const add = useAddCanvasserNote(contactId)
  const addNote = add.mutate
  const notes = [...detail.notes].sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
  const save = () => {
    const noteText = text.trim()
    if (!noteText) return
    addNote({ noteText }, { onSuccess: () => { setText(''); toaster.create({ type: 'success', title: 'Saved' }) } })
  }
  return (
    <VStack align="stretch" gap={2}>
      {notes.length === 0 && <Text fontSize="sm" color="fg.muted">No notes yet.</Text>}
      {notes.map(n => (
        <Box key={n.id} p={3} borderWidth="1px" borderColor="border" borderRadius="md">
          <Text fontSize="sm" whiteSpace="pre-wrap">{n.noteText}</Text>
          <Text fontSize="xs" color="fg.muted" mt={1}>{`${n.creatorName} · ${shortDay(n.createdAt)}`}</Text>
        </Box>
      ))}
      {isOnline ? (
        <VStack align="stretch" gap={2}>
          <Textarea aria-label="Add a note" placeholder="Add a note" rows={3} maxLength={MAX_NOTE} value={text} onChange={e => setText(e.target.value)} />
          <HStack justify="flex-end">
            <Button minH="44px" bg="accent" color="accent.fg" disabled={!text.trim() || add.isPending} onClick={save}>Save note</Button>
          </HStack>
        </VStack>
      ) : (
        <Text fontSize="sm" color="fg.muted">Adding a note needs a connection.</Text>
      )}
    </VStack>
  )
}
